// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ba55842c","703":"f50831d0","787":"ca0a75dd"}[chunkId] + ".chunk.js";
};